import { v4 as uuid } from "uuid";
import {
  cb,
  cbase,
  fisBook,
  mikhBook,
  premBoard,
  product1,
  rBoard,
  rPieces,
  siclBook,
} from "../../assets";
/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 4,
    title: "Chess Kit",
    categoryName: "Pieces",
    price: 499,
    initialPrice: 699,
    discountPrice: "44% off",
    image: product1,
    alt: "p2",
    isTrending: true,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "Chess pieces are distinguished by appearance and made of rigid material such as wood, ivory, or plastic. Pieces are of contrasting colours, commonly white and black. The six different types of pieces are: king, rook, bishop, queen, knight, and pawn. More than 500 different patterns of chess pieces have been recorded.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 5,
    title: "Premium Board",
    categoryName: "Board",
    price: 999,
    initialPrice: 1999,
    discountPrice: "44% off",
    image: premBoard,
    alt: "p1",
    isTrending: true,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "A board of 64 squares arranged in eight vertical rows called files and eight horizontal rows called ranks. These squares alternate between two colours: one light, such as white, beige, or yellow; and the other dark, such as black or green.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 4.5,
    title: "Chess Board",
    categoryName: "Board",
    price: 849,
    initialPrice: 949,
    discountPrice: "44% off",
    image: cb,
    alt: "p3",
    isTrending: false,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "A board of 64 squares arranged in eight vertical rows called files and eight horizontal rows called ranks. These squares alternate between two colours: one light, such as white, beige, or yellow; and the other dark, such as black or green.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 2,
    title: "Chess Base",
    categoryName: "Board",
    price: 249,
    initialPrice: 449,
    discountPrice: "44% off",
    image: cbase,
    alt: "p4",
    isTrending: true,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "A board of 64 squares arranged in eight vertical rows called files and eight horizontal rows called ranks. These squares alternate between two colours: one light, such as white, beige, or yellow; and the other dark, such as black or green.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 3.5,
    title: "Mikhail Tal",
    categoryName: "Book",
    price: 349,
    initialPrice: 449,
    discountPrice: "44% off",
    image: mikhBook,
    alt: "p5",
    isTrending: false,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "A chess book lists different tutorials and analysis of moves to help players grow. A book move is a move that is well-known to opening theory. In other words, a book move is an opening move that is considered standard or conventional.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 4.5,
    title: "Royal Chess Pieces",
    categoryName: "Pieces",
    price: 699,
    initialPrice: 899,
    discountPrice: "44% off",
    image: rPieces,
    alt: "p6",
    isTrending: true,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "Chess pieces are distinguished by appearance and made of rigid material such as wood, ivory, or plastic. Pieces are of contrasting colours, commonly white and black. The six different types of pieces are: king, rook, bishop, queen, knight, and pawn. More than 500 different patterns of chess pieces have been recorded.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 1,
    title: "Royal Board",
    categoryName: "Board",
    price: 899,
    initialPrice: 999,
    discountPrice: "44% off",
    image: rBoard,
    alt: "p7",
    isTrending: false,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "A board of 64 squares arranged in eight vertical rows called files and eight horizontal rows called ranks. These squares alternate between two colours: one light, such as white, beige, or yellow; and the other dark, such as black or green.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 5,
    title: "Bobby Fischer",
    categoryName: "Book",
    price: 249,
    initialPrice: 449,
    discountPrice: "44% off",
    image: fisBook,
    alt: "p8",
    isTrending: false,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "A chess book lists different tutorials and analysis of moves to help players grow. A book move is a move that is well-known to opening theory. In other words, a book move is an opening move that is considered standard or conventional.",
  },
  {
    _id: uuid(),
    inCart: false,
    inWishlist: false,
    rating: 3.5,
    title: "Sicilian Defence",
    categoryName: "Book",
    price: 399,
    initialPrice: 499,
    discountPrice: "44% off",
    image: siclBook,
    alt: "p9",
    isTrending: false,
    outOfStock: false,
    cartItemCount: 0,
    description:
      "A chess book lists different tutorials and analysis of moves to help players grow. A book move is a move that is well-known to opening theory. In other words, a book move is an opening move that is considered standard or conventional.",
  },
];
